import { DateTime } from 'luxon';

export class StoreDayHours {
	constructor(
		private open_: DateTime,
		private close_: DateTime
	) {}

	get open(): DateTime {
		return this.open_;
	}

	get close(): DateTime {
		return this.close_;
	}

	toJSON(): { open: string; close: string } {
		return {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			open: this.open.toISO()!,
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			close: this.close.toISO()!
		};
	}
}
